<template>
    <div class="p-wujie-cj-detail">
        <div class="m-header">
            <div class="m-header__logo">
                <a class="m-logo" :href="rootPath">
                    <img class="u-logo" src="@/assets/img/logo.png" alt="JX3BOX" />
                </a>
                <div class="m-info">
                    <div class="u-title">魔盒成就百科</div>
                    <div class="u-stat">
                        魔盒数据库已收录 -
                        <span class="u-stat-item" v-for="(text, key) in countDict" :key="key">
                            <em>{{ text }}</em>
                            <span>:</span>
                            <b>{{ count[key] }}</b>
                        </span>
                    </div>
                </div>
            </div>
            <el-dropdown class="m-header__links">
                <el-button type="primary" class="u-dropdown-link">
                    更多百科<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu class="m-header__menu" slot="dropdown">
                    <el-dropdown-item class="u-dropdown-link">
                        <a :href="`${rootPath}adventure`">奇遇大全</a>
                    </el-dropdown-item>
                    <el-dropdown-item class="u-dropdown-link">
                        <a :href="`${rootPath}pet`">宠物大全</a>
                    </el-dropdown-item>
                    <el-dropdown-item class="u-dropdown-link">
                        <a :href="`${rootPath}horse`">坐骑大全</a>
                    </el-dropdown-item>
                    <el-dropdown-item class="u-dropdown-link">
                        <a :href="`${rootPath}furniture`">家具大全</a>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div class="m-content-wrapper">
            <div class="m-strategy-content">
                <!-- 进阶类成就 -->
                <div class="m-series" v-if="seriesList.length">
                    <router-link
                        class="u-series"
                        :class="item.ID == source.ID ? 'active' : ''"
                        v-for="item in seriesList"
                        :key="item.ID"
                        :to="{
                            name: 'wujie-cj-detail',
                            params: { source_id: item.ID },
                        }"
                    >
                        <div class="u-series__left">
                            <img class="u-icon" :src="icon_url(item.IconID)" />
                            <div class="u-name">{{ item.Name }}</div>
                        </div>
                        <div class="u-series__right">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="12" height="12" viewBox="0 0 12 12" fill="none" v-bind:class="'u-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="url(#pattern_fill_2_201)" d="M0 0h12v12H0z"/><defs><pattern id="pattern_fill_2_201" patternContentUnits="objectBoundingBox" width="1" height="1"><use transform="scale(.0125)" xlink:href="#image0"/></pattern><image id="image0" width="80" height="80" xlink:href="data:image/png;base64,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"/></defs></svg>
                            <div class="u-num">{{ item.Point }}</div>
                        </div>
                    </router-link>
                </div>
                <!-- 攻略 -->
                <div class="m-strategy">
                    <div class="m-title">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" v-bind:class="'u-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M14.718 9.842l1.195-1.176-.568-1.577.568-1.578-1.195-1.176-.176-1.667-1.586-.54L12.076.7l-1.664.201L9 0 7.588.901l-1.665-.2-.88 1.427-1.585.54-.176 1.667-1.195 1.176.568 1.578-.568 1.577 1.195 1.176.176 1.667.88.3-1.509 4.718 2.584-.143L7.434 18l1.281-4.004.285.181.285-.181L10.565 18l2.022-1.616 2.584.143-1.51-4.718.881-.3.176-1.667zm-7.822 6.376l-1.139-.91-1.456.08.957-2.99.665 1.079 1.665-.201.207.132-.9 2.81zm5.347-.91l-1.139.91-.899-2.81.207-.132 1.665.201.665-1.079.956 2.99-1.455-.08zm1.32-4.58l-1.306.445-.724 1.175-1.37-.165L9 12.925l-1.163-.742-1.37.165-.724-1.175-1.306-.445-.145-1.373-.983-.967.467-1.3L3.31 5.79l.983-.968.145-1.372 1.306-.446.724-1.175 1.37.166L9 1.252l1.163.743 1.37-.166.724 1.175 1.306.446.145 1.372.983.968-.468 1.299.468 1.299-.983.967-.145 1.373z" fill="#FFF"/><path d="M9 2.98A4.112 4.112 0 004.892 7.09 4.112 4.112 0 009 11.196a4.112 4.112 0 004.108-4.107A4.112 4.112 0 009 2.98zm0 7.16A3.056 3.056 0 015.948 7.09 3.056 3.056 0 019 4.037a3.056 3.056 0 013.052 3.052A3.056 3.056 0 019 10.14z" fill="#FFF"/></svg>
                        <div class="u-title">成就攻略</div>
                    </div>

                    <div class="m-detail">
                        <div class="m-wiki-post-panel" v-if="wiki_post && wiki_post.post">
                            <WikiPanel :wiki-post="wiki_post">
                                <div slot="meta" class="m-meta-list">
                                    <!-- 参与贡献 -->
                                    <div class="m-user-info">
                                        <div class="u-meta" v-if="wiki_post.users && wiki_post.users.length">
                                            <em class="u-label">参与贡献</em>
                                            <div class="m-users">
                                                <a
                                                    class="u-value u-creator"
                                                    v-for="(user, key) in wiki_post.users.slice(0, 3)"
                                                    :key="key"
                                                    target="_blank"
                                                    :href="user.id ? author_url(user.id) : null"
                                                >
                                                    <img
                                                        class="u-user"
                                                        :src="thumbnail_url(user.avatar)"
                                                        :alt="user.nickname"
                                                        :title="user.nickname"
                                                    />
                                                </a>
                                                <span class="u-more" v-if="userLength > 3">
                                                    +{{ userLength - 3 > 999 ? 999 : userLength - 3 }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="m-article-info">
                                        <div class="m-version" v-if="versions.length">
                                            攻略版本：v{{ versions.length }}
                                        </div>
                                        <div class="m-wiki-signature">
                                            本次修订由 <b>{{ user_name }}</b> 提交于{{ updated_at }}
                                        </div>
                                    </div>
                                </div>
                                <template slot="body">
                                    <div class="m-wiki-compatible" v-if="compatible">
                                        <i class="el-icon-warning-outline"></i>
                                        暂无缘起攻略，以下为重制攻略，仅作参考，<a
                                            class="s-link"
                                            :href="publish_url(`achievement/${id}`)"
                                            >参与修订</a
                                        >。
                                    </div>
                                    <Article :content="wiki_post.post.content" />
                                </template>
                            </WikiPanel>
                        </div>

                        <div class="m-wiki-post-empty" v-if="is_empty">
                            <i class="el-icon-s-opportunity"></i>
                            <span>暂无攻略，我要</span>
                            <a class="s-link" :href="publish_url(`achievement/${id}`)">完善攻略</a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 评论 -->
            <div class="m-comment">
                <div class="m-title">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" v-bind:class="'u-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" fill="#FFF" d="M2.25 2.25A.75.75 0 001.5 3v13.875l3.341-2.625H15.75a.75.75 0 00.75-.75V3a.75.75 0 00-.75-.75H2.25zM3 3.75v10.039l1.322-1.039H15v-9H3zm2.625 4.879c0 .746.208 1.207.594 1.616a1.45 1.45 0 001.03.443c.725 0 1.313-.588 1.313-1.313a1.32 1.32 0 00-1.21-1.309 1.645 1.645 0 00-.36.007v-.012c0-.256-.002-1.32 1.23-1.986l-.336-.516c-1.34.581-2.261 1.757-2.261 3.07zm3.75 0c0 .746.208 1.207.594 1.616a1.45 1.45 0 001.03.443c.725 0 1.313-.588 1.313-1.313a1.32 1.32 0 00-1.21-1.309 1.645 1.645 0 00-.36.007v-.012c0-.257-.002-1.32 1.23-1.986l-.336-.516c-1.34.581-2.261 1.757-2.261 3.07z"/></svg>
                    <div class="u-title">百科评论</div>
                </div>
                <WikiComments class="m-comment-detail" type="achievement" :source-id="id" />
            </div>
        </div>
    </div>
</template>

<script>
import { __Root, __OriginRoot } from "@jx3box/jx3box-common/data/jx3box.json";

import { postStat, postHistory } from "@jx3box/jx3box-common/js/stat";
import { wiki } from "@jx3box/jx3box-common/js/wiki_v2";
import { publishLink } from "@jx3box/jx3box-common/js/utils";
import { ts2str, authorLink, showAvatar, iconLink } from "@jx3box/jx3box-common/js/utils.js";
import { reportNow } from "@jx3box/jx3box-common/js/reporter";
import User from "@jx3box/jx3box-common/js/user";

import { getAchievementsTotal, get_achievement } from "@/service/achievement";

import WikiPanel from "@/components/wiki-panel.vue";
import Article from "@jx3box/jx3box-editor/src/Article.vue";
import WikiComments from "@/components/wiki-comments.vue";
export default {
    name: "WujieDetail",
    components: {
        WikiPanel,
        Article,
        WikiComments,
    },
    data() {
        return {
            params: new URLSearchParams(location.search),
            generalNum: 137, // 和游戏差异，固定加上
            count: {},
            countDict: {
                general: "常规成就数",
                general_point: "常规资历数",
                armor: "五甲成就数",
                armor_point: "五甲资历数",
                // post_count: "收录攻略数",
            },

            source: "",
            wiki_post: "",
            compatible: false,
            is_empty: true,
            versions: [],
        };
    },
    computed: {
        client: function () {
            let client = this.params.get("L") == "classic_yq" ? "origin" : "std";
            return client;
        },
        rootPath: function () {
            return this.client == "origin" ? __OriginRoot : __Root;
        },
        id() {
            return this.$route.params.source_id;
        },
        post_id: function () {
            return this.$route.params.post_id;
        },
        isRevision: function () {
            return !!this.$route.params.post_id;
        },
        author_id: function () {
            return ~~this.wiki_post.post.user_id;
        },
        user_name: function () {
            return this.wiki_post?.post?.user_nickname;
        },
        updated_at: function () {
            return ts2str(this.wiki_post?.post?.updated);
        },
        authors: function () {
            if (!this.isRevision) {
                return (
                    this.wiki_post?.users
                        ?.filter((user) => user.id)
                        ?.map((user) => {
                            return {
                                user_id: user.id,
                                user_avatar: user.avatar,
                                display_name: user.nickname,
                            };
                        }) || []
                );
            }
            return [];
        },
        favTitle: function () {
            return this.wiki_post?.source?.Name;
        },
        prefix() {
            return this.client === "std" ? "www" : "origin";
        },
        seriesList() {
            return this.source?.SeriesAchievementList || [];
        },
        userLength: function () {
            return this.wiki_post?.users?.length;
        },
    },
    watch: {
        id: {
            handler() {
                this.loadData();
            },
        },
        post_id: {
            handler() {
                this.loadRevision();
            },
        },
    },
    created() {
        this.getStat();
    },
    mounted() {
        if (this.post_id) {
            this.loadRevision();
        } else {
            this.loadData();
        }
    },
    methods: {
        icon_url: function (id) {
            return iconLink(id, this.client);
        },
        author_url: authorLink,
        ts2str,
        thumbnail_url: function (val) {
            return showAvatar(val);
        },
        publish_url: publishLink,
        triggerStat: function () {
            if (this.client == "origin") {
                postStat("origin_cj", this.id);
            } else {
                postStat("cj", this.id);
            }
        },
        loadData: function () {
            // 获取最新攻略
            if (this.id) {
                get_achievement(this.id, { client: this.client }).then((res) => {
                    this.source = res?.data?.data?.achievement || "";
                });
                wiki.mix({ type: "achievement", id: this.id, client: this.client }).then((res) => {
                    const { post, source, compatible, isEmpty, users } = res;
                    this.wiki_post = {
                        post: post,
                        source: source,
                        users,
                    };
                    this.is_empty = isEmpty;
                    this.compatible = compatible;

                    reportNow({
                        caller: "cj_detail",
                        data: {
                            href: `${this.prefix}:/cj/view/${this.id}`,
                        },
                    });

                    User.isLogin() && postHistory({
                        source_type: "wujie",
                        source_id: ~~this.id,
                        link: location.href,
                        title: post.title,
                    });
                });

                wiki.versions({ type: "achievement", id: this.id }, { client: this.client }).then(
                    (res) => {
                        res = res.data;
                        this.versions = res.data || [];
                    },
                    () => {
                        this.versions = [];
                    }
                );
            }
            this.triggerStat();
        },
        loadRevision: function () {
            // 获取指定攻略
            wiki.getById(this.post_id).then((res) => {
                this.wiki_post = {
                    ...this.wiki_post,
                    post: res.data.data?.post,
                };
            });
            this.triggerStat();
        },
        getStat() {
            // 获取成就统计信息
            getAchievementsTotal().then((data) => {
                data = data.data;
                this.count = data.data.count;
                this.count.general = ~~this.count?.general + this.generalNum;
            });
        },
    },
};
</script>

<style lang="less">
@import "~@/assets/css/wujie/cj-detail.less";
</style>
